import type { GradientBlock } from "../api/gradient";

function fmt(v: number): string {
  if (!Number.isFinite(v)) return "—";
  const a = Math.abs(v);
  if (a !== 0 && (a >= 10000 || a < 0.001)) return v.toExponential(1);
  return v.toFixed(a >= 10 ? 1 : 3);
}

// Horizontal bars of ‖∂loss/∂θ‖ per parameter block — where learning flows.
// Bar length ∝ norm (relative to the largest block).
export function GradientBlocks({ blocks }: { blocks: GradientBlock[] }) {
  if (blocks.length === 0) return <div className="viz-empty">no gradient blocks</div>;
  const maxNorm = Math.max(...blocks.map((b) => (Number.isFinite(b.norm) ? b.norm : 0)), 1e-12);
  return (
    <div className="grad-blocks mono">
      {blocks.map((b) => {
        const pct = Math.max(0, Math.min(100, (b.norm / maxNorm) * 100));
        return (
          <div className="grad-block" key={b.name}>
            <div className="grad-block-head">
              <span className="grad-block-name">{b.name}</span>
              <span className="dim">{fmt(b.norm)}</span>
            </div>
            <div className="grad-block-track">
              <div className="grad-block-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
